import { useEffect, useState } from 'react';
import { isWithinBreakpoint } from '@App/common/helpers/isWithinBreakpoint';
export const useDeviceDetect = themeBreakpoints => {
  const {
    0: deviceType,
    1: setDeviceType
  } = useState('');
  useEffect(() => {
    const checkDeviceType = () => {
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const deviceTypes = Object.keys(themeBreakpoints);
      for (let i = 0; i < deviceTypes.length; i++) {
        const type = deviceTypes[i];
        if (isWithinBreakpoint(themeBreakpoints[type], width)) {
          setDeviceType(type);
          return;
        }
      }

      // Default to the largest defined breakpoint if no other match
      const largestDefinedBreakpoint = deviceTypes.at(-1);
      setDeviceType(largestDefinedBreakpoint);
    };
    checkDeviceType();
    window.addEventListener('resize', checkDeviceType);
    return () => window.removeEventListener('resize', checkDeviceType);
  }, [themeBreakpoints]);
  return {
    deviceType
  };
};